var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GetFile',_vm._b({attrs:{"with-title":false,"loader":_vm.loader},on:{"get-file":_vm.getPdf}},'GetFile',_vm.$attrs,false),[_c('template',{slot:"icon"},[_c('HintingIcon',{attrs:{"class-name":"mr-2","icon":_vm.ICONS.QR_CODE,"tooltip":_vm.$t('actions.qr_code')}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }